module.exports = __webpack_public_path__ + "img/team_rank_icon.7f7fa10f.jpg";